import { useState, useRef, useEffect } from "react";
import Typeahead from "../Form/Typeahead";
import {
  handleFormikValueChange,
  convertSpecificationKeyToLabel,
} from "../../utils";
import { withApi, apiShape, withNotifier, notifierShape } from "../../context";
import { withIntl } from "../../wrappers";

type Props = {
  api: apiShape;
  valueArrayName: string;
  notifier: notifierShape;
  specificationKeysEndpoint: string;
  objIdx: number;
  values: {
    specifications?: $TSFixMe;
  };
};

export function SpecificationKeyTypeahead(props: Props) {
  const [specificationKeys, setSpecificationKeys] = useState([]);
  const [fetching, setFetching] = useState();
  const selectedOption = useRef();
  const {
    api,
    valueArrayName,
    notifier,
    specificationKeysEndpoint,
    objIdx,
    values,
  } = props;

  const loadKeys = async (searchText = "") => {
    try {
      if (searchText.length < 101) {
        // @ts-expect-error TS(2345) FIXME: Argument of type 'true' is not assignable to param... Remove this comment to see the full error message
        setFetching(true);

        const response = await api.get(specificationKeysEndpoint, {
          ui_visible: true,
          key: `${searchText}*`,
        });

        setSpecificationKeys(
          response.specification_keys.map((key: $TSFixMe) => ({
            id: key,
            name: convertSpecificationKeyToLabel(key),
          })),
        );
      }
    } catch (error) {
      notifier.showError(api.translateError(error));
    } finally {
      // @ts-expect-error TS(2345) FIXME: Argument of type 'false' is not assignable to para... Remove this comment to see the full error message
      setFetching(false);
    }
  };

  const options = specificationKeys.filter(
    (option) =>
      !values.specifications.find(
        // @ts-expect-error TS(7006) FIXME: Parameter 'specification' implicitly has an 'any' ... Remove this comment to see the full error message
        (specification) =>
          (specification as $TSFixMe).key?.name === (option as $TSFixMe).name,
      ),
  );

  useEffect(() => {
    const selectedOptionLabel =
      values &&
      // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      values[valueArrayName] &&
      // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      values[valueArrayName][objIdx].key?.name;
    selectedOption.current =
      specificationKeys.find(
        (option) => (option as $TSFixMe).name === selectedOptionLabel,
      ) ||
      (values &&
        // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        values[valueArrayName] &&
        // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        values[valueArrayName][objIdx].key !== "" &&
        // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        values[valueArrayName][objIdx].key) ||
      undefined;
  }, [values, specificationKeys]);

  return (
    <Typeahead
      {...props}
      onChange={(value) => handleFormikValueChange(props, value)}
      selectedOption={selectedOption.current}
      options={options}
      fetching={fetching}
      loadOptions={loadKeys}
      loadOptionsOnMount
      canCreate
    />
  );
}

// @ts-expect-error TS(2345) FIXME: Argument of type '{ (props: Readonly<Omit<Readonly... Remove this comment to see the full error message
export default withIntl(withNotifier(withApi(SpecificationKeyTypeahead)));
